import useGeoLocationLocance from '@/hooks/useGeoLocationLocance';
import useGeoLocationGeolocs from '@/hooks/useGeoLocationGeolocs';
import React from 'react';

export const GeolocsGate = () => {
  useGeoLocationGeolocs();
  return null;
};

export const LocanceGate = () => {
  useGeoLocationLocance();
  return null;
};

export const GeolocationManager = () => {
  return <GeolocsGate />;
};
